var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showModal)?_c('div',_vm._g({staticClass:"window-modal",attrs:{"id":"window-modal","role":"dialog"}},_vm.$listeners),[_c('div',{staticClass:"window-modal__wrapper",attrs:{"id":"window-modal-wrapper","tabindex":"0"}},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }